module.exports = __webpack_public_path__ + "sh.c47ee33b97f3e7da9405.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/sh.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/sh.svg
// module chunks = styles